import React, { useState } from "react"

import {
  Section,
  Container,
  HeaderRow,
  Eyebrow,
  CategoryTabs,
  CategoryButton,
  LogoRow,
  LogoTile,
  LogoImage,
  EmptyState,
} from "./styles"

import EitFoodEuLogo from "../../../assets/eit-food-eu-logo.png"
import ClayCapitalLogo from "../../../assets/clay-capital-logo.svg"
import KadmosLogo from "../../../assets/kadmos-logo.png"
import PincLogo from "../../../assets/pinc-logo.png"
import AgFunderLogo from "../../../assets/agfunder-logo.svg"
import SynBioVenLogo from "../../../assets/synbioven-logo.png"
import FarvatnLogo from "../../../assets/farvatn-logo.svg"
import SosvLogo from "../../../assets/sosv-logo.png"
import SavantusLogo from "../../../assets/savantus-logo.png"

const CATEGORIES = ["Investors", "Collaborators"]

// No Prismic slice for this yet, so — same approach as Team's CATEGORY_MAP —
// membership is maintained here directly until content is fed from the CMS.
const INVESTORS = [
  { name: "Clay Capital", logo: ClayCapitalLogo, url: "https://www.claycapital.vc/" },
  { name: "Kadmos Capital", logo: KadmosLogo, url: "https://kadmoscapital.com/" },
  { name: "PINC — Paulig Incubator", logo: PincLogo, url: "https://www.pauliggroup.com/this-is-pinc" },
  { name: "AgFunder", logo: AgFunderLogo, url: "https://agfunder.com/" },
  { name: "SynBioVen", logo: SynBioVenLogo, url: "https://www.synbioven.com/" },
  { name: "Farvatn Venture", logo: FarvatnLogo, url: "https://www.farvatnventure.com/" },
  { name: "SOSV", logo: SosvLogo, url: "https://sosv.com/" },
  { name: "Savantus Ventures", logo: SavantusLogo, url: "https://savantusventures.com/" },
]

const COLLABORATORS = [
  {
    name: "EIT Food / European Union",
    logo: EitFoodEuLogo,
    url: "https://www.eitfood.eu/",
  },
]

const DATA = {
  Investors: INVESTORS,
  Collaborators: COLLABORATORS,
}

const Supporters = () => {
  const [activeCategory, setActiveCategory] = useState(CATEGORIES[0])
  const items = DATA[activeCategory]

  return (
    <Section id="supporters">
      <Container>
        <HeaderRow>
          <Eyebrow>Supported by</Eyebrow>

          <CategoryTabs>
            {CATEGORIES.map(category => (
              <CategoryButton
                key={category}
                active={category === activeCategory}
                onClick={() => setActiveCategory(category)}
              >
                {category}
              </CategoryButton>
            ))}
          </CategoryTabs>
        </HeaderRow>

        {items.length > 0 ? (
          <LogoRow>
            {items.map(item => (
              <LogoTile
                key={item.name}
                as={item.url ? "a" : "div"}
                href={item.url}
                target={item.url ? "_blank" : undefined}
                rel={item.url ? "noopener noreferrer" : undefined}
              >
                <LogoImage src={item.logo} alt={item.name} />
              </LogoTile>
            ))}
          </LogoRow>
        ) : (
          <EmptyState>Logos coming soon</EmptyState>
        )}
      </Container>
    </Section>
  )
}

export default Supporters
